import Vue from 'vue';
import SearchDropdown from '../mock/SearchDropdown.vue';
export default Vue.extend({
    components: { SearchDropdown },
    props: {
        value: {
            type: String,
            default: '',
        },
        placehoderText: {
            type: String,
            default: 'Search',
        },
        displayInHeader: {
            type: Boolean,
            default: false,
        },
        result: {
            type: Object,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        isNavSearchActive: {
            type: Boolean,
            default: false,
        },
        mobile: {
            type: Boolean,
            default: false,
        },
        recentSearches: {
            type: Array,
            default: [],
        },
        showLeftButton: {
            type: Boolean,
            default: false,
        },
        largePadding: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
        this.updatePageDim(this.isNavSearchActive);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
        this.updatePageDim(false);
    },
    methods: {
        clear() {
            this.$emit('clear');
        },
        isIOS() {
            // covers iPhone/iPad + iPadOS reporting as Mac
            return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
                (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        },
        openAndScroll() {
            // 1) open immediately within the gesture
            this.$emit('open');
            // 2) scroll immediately (still within gesture timing)
            this.scrollSearchToTop();
            // 3) focus without letting Safari auto-scroll (best effort)
            this.$nextTick(() => {
                const input = this.$refs.searchInput;
                if (!input)
                    return;
                try {
                    // supported in modern Safari; if unsupported it will throw / ignore
                    input.focus({ preventScroll: true });
                }
                catch {
                    input.focus();
                }
            });
        },
        scrollSearchToTop() {
            this.$nextTick(() => {
                const el = this.$refs.searchBar;
                if (!el)
                    return;
                const headerOffset = 175;
                const rect = el.getBoundingClientRect();
                const scroller = (document.scrollingElement || document.documentElement);
                const target = Math.max(0, scroller.scrollTop + rect.top - headerOffset);
                const behavior = this.isIOS() ? 'auto' : 'smooth';
                scroller.scrollTo({ top: target, behavior });
                // iOS sometimes ignores the first scroll during viewport/keyboard settling
                if (this.isIOS()) {
                    setTimeout(() => scroller.scrollTo({ top: target, behavior: 'auto' }), 50);
                }
            });
        },
        goToSearchPage() {
            if (this.value) {
                this.$emit('goToSearchPage');
            }
        },
        handleClickOutside(event) {
            const el = this.$el;
            if (el && !el.contains(event.target)) {
                this.$emit('close');
            }
        },
        updatePageDim(active) {
            const root = document.documentElement;
            if (active)
                root.classList.add('search-dim');
            else
                root.classList.remove('search-dim');
        },
    },
});
